<div class="app-menu" (window:resize)="onResize()">
  <mat-toolbar class="dashboard-toolbar" [class.blurred]="!isFirefox">
    <header class="dashboard__header">
      <button class="icon" mat-icon-button (click)="toggleSideNav()">
        <mat-icon svgIcon="menu-hamburger"></mat-icon>
      </button>
           <img routerLink="/public/dashboard" class="ml-8 mr-8 logo-img"
        [src]="account?.schools?.profile_image ? (account?.schools?.profile_image | staticFile) + '?image_size=m' : 'assets/imgs/logo-mlvt.png'"
        alt="logo-image" [width]="80" [height]="80" />
      <h1 routerLink="/public/dashboard">ប្រព័ន្ធគ្រប់គ្រងព័ត៌មានវិទ្យា អ.ប.វ (TVETMIS)</h1>
      <div class="header-action">
        <button class="languages" mat-button [matMenuTriggerFor]="dropMenu"
          aria-label="Example icon-button with a menu">
          <span>{{browserLang === 'en' ? (browserLang | uppercase) : 'ខ្មែរ'}}</span>
          <mat-icon svgIcon="{{browserLang === 'en' ? 'english_flag' : 'khmer_flag'}}"></mat-icon>
          <mat-icon iconPositionEnd>expand_more</mat-icon>
        </button>
        <mat-menu #dropMenu="matMenu">
          <div>
            <button mat-menu-item *ngFor="let lang of langs | keyvalue: originalOrder" (click)="useLanguage(lang.key)">
              <mat-icon svgIcon="{{lang.key === 'en' ? 'english_flag' : 'khmer_flag'}}"></mat-icon>
              <span>{{ lang.value }}</span>
              <span *ngIf="browserLang === lang.key" class="flex pl-8"><mat-icon svgIcon="check"></mat-icon></span>
            </button>
          </div>
        </mat-menu>

        <!-- <div class="avatar">
          <button mat-menu-item (click)="login()"><mat-icon>login</mat-icon>{{'button.login' |
            translate}}</button>
        </div> -->
      </div>
    </header>
  </mat-toolbar>
  <mat-sidenav-container class="app-container" autosize>
    <mat-sidenav #sidenav class="menu-sidenav" [class.large-width]="mobileQuery || isExpanded"
      [mode]="mobileQuery ? 'over' : 'side'" [opened]="!mobileQuery" [disableClose]="!mobileQuery">

      <mat-nav-list class="menu-list" id="list-nav">
        <div *ngFor="let m of menu">
          <mat-list-item #tooltip="matTooltip" [matTooltip]="!isExpanded ? (m.title | translate) : ''"
            matTooltipPosition="right" *ngIf="m.child.length <= 0 " [routerLink]="m.route"
            [routerLinkActive]="m.route ? 'active' : ''" [routerLinkActiveOptions]="{exact:false}">
            <span class="menu-item-title" *ngIf="isExpanded">{{ m.title | translate}}</span>
            <mat-icon mat-list-icon *ngIf="m.svgIcon !== '' " [svgIcon]="m.svgIcon"
              [class.svg-active]="m.route && route.url.includes(m.route)">
            </mat-icon>
          </mat-list-item>

          <mat-expansion-panel *ngIf="m.child.length > 0 && isExpanded; else shrink" class="expansion-panel"
            [class.parents]="isChildActive(m.child)">
            <mat-expansion-panel-header [class.active]="isChildActive(m.child)" #tooltipParent="matTooltip"
              [matTooltip]="!isExpanded ? (m.title | translate) : ''" matTooltipPosition="right">
              <mat-icon mat-list-icon *ngIf="m.icon !== ''">{{ m.icon }}</mat-icon>
              <mat-icon mat-list-icon *ngIf="m.svgIcon !== ''" [svgIcon]="m.svgIcon"></mat-icon>

              <span class="menu-item-title" *ngIf="isExpanded">{{m.title | translate}}</span>
            </mat-expansion-panel-header>
            <mat-nav-list class="expansion-panel-body">
              <mat-list-item #tooltip="matTooltip" [matTooltip]="!isExpanded ? (c.title | translate) : ''"
                matTooltipPosition="right" *ngFor="let c of m.child" class=" {{ isExpanded ? 'expand' : 'no-expand' }}"
                [routerLink]="c.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact : false}">
                <span class="menu-item-title">{{ c.title | translate}}</span>
                <mat-icon mat-list-icon *ngIf="c.icon !== '' && !isExpanded">{{ c.icon }}</mat-icon>
                <mat-icon mat-list-icon *ngIf="c.svgIcon !== '' && !isExpanded" [svgIcon]="c.svgIcon"></mat-icon>
              </mat-list-item>
            </mat-nav-list>
          </mat-expansion-panel>

          <ng-template #shrink>
            <mat-list-item #tooltip="matTooltip" [matTooltip]="!isExpanded ? (m.title | translate) : ''"
              matTooltipPosition="right" *ngIf="m.child.length > 0 " [class.active]="isChildActive(m.child)"
              [matMenuTriggerFor]="narrow" [ngClass]="{'triangle': !isExpanded}">
              <span class="menu-item-title" *ngIf="isExpanded">{{ m.title | translate}}</span>
              <mat-icon mat-list-icon *ngIf="m.svgIcon !== '' " [svgIcon]="m.svgIcon"
                [class.svg-active]="m.route && route.url.includes(m.route)">
              </mat-icon>
              <mat-icon mat-list-icon *ngIf="m.icon !== '' "
                [class.svg-active]="m.route && route.url.includes(m.route)">
                {{m.icon}}
              </mat-icon>
              <mat-icon iconPositionEnd>chevron_right</mat-icon>
            </mat-list-item>

            <mat-menu #narrow="matMenu" [overlapTrigger]="true" backdropClass="nav-mat-menu">
              <mat-nav-list class="expansion-panel-body">
                <mat-list-item *ngFor="let c of m.child" [routerLink]="c.route" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact:false}">
                  <span class="menu-item-title">{{ c.title | translate}}</span>
                </mat-list-item>
              </mat-nav-list>
            </mat-menu>
          </ng-template>
        </div>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content [class.explicit-sm-ml]="!mobileQuery && !isExpanded"
      [class.explicit-lg-ml]=" !mobileQuery  && isExpanded" id="sidenav-content">
      <div class="menu-sidenav-content app-root-content" [class.nav-text-hidden]="!isExpanded"
        [class.nav-text-show]="isExpanded">

        <section class="dash-row ">
          <router-outlet></router-outlet>
        </section>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
